<div *ngFor="let alert of alerts" class="{{cssClass(alert)}} alert-dismissable">
  {{alert.message}}
  <a class="btn-close float-end" (click)="removeAlert(alert)"></a>
</div>
